/* CERISAINE - tous les boutons d'appel a l'action ramenent vers la section
   "Informations produit" et son selecteur de quantite / d'option.

   Note : sur ce theme, window.scrollTo({behavior:'smooth'}) ne fait rien
   (aucune erreur levee, la page ne bouge simplement pas). On anime donc
   nous-memes avec requestAnimationFrame + scrollTo(x, y), qui fonctionne. */
(function () {
  'use strict';

  if (window.__crsScrollReady) return; // l'asset est charge par plusieurs sections
  window.__crsScrollReady = true;

  var QTY_SELECTORS = [
    '.quantity-breaks-container',
    '.quantity-break',
    'input[name="quantity"]',
    '.product-form__quantity',
    'quantity-input',
    '.product-block--quantity',
    '.product-form__input--quantity'
  ];

  var MAIN_SELECTORS = [
    '#shopify-section-main',
    '[id^="shopify-section"][id$="__main"]',
    '.product-single__meta',
    '.product__info-wrapper',
    '.product-single'
  ];

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function pick(list) {
    for (var i = 0; i < list.length; i++) {
      var nodes = document.querySelectorAll(list[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (visible(nodes[j])) return nodes[j];
      }
    }
    return null;
  }

  function headerOffset() {
    var h = document.querySelector(
      '.site-header--fixed, .header--sticky, sticky-header, .shopify-section-header-sticky, #shopify-section-header'
    );
    if (!h) return 16;
    var pos = window.getComputedStyle(h).position;
    if (pos === 'fixed' || pos === 'sticky') return h.getBoundingClientRect().height + 16;
    return 16;
  }

  function maxScroll() {
    return Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight
    );
  }

  var animating = false;

  function animateTo(targetY, duration, done) {
    targetY = Math.max(0, Math.min(targetY, maxScroll()));
    var startY = window.pageYOffset;
    var delta = targetY - startY;
    if (Math.abs(delta) < 2) { if (done) done(); return; }

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      window.scrollTo(0, targetY);
      if (done) done();
      return;
    }

    var start = null;
    var ticked = false;
    var finished = false;
    animating = true;

    function finish() {
      if (finished) return;
      finished = true;
      animating = false;
      if (done) done();
    }

    function step(ts) {
      if (finished) return;
      ticked = true;
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      // easeInOutCubic
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, Math.round(startY + delta * e));
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        finish();
      }
    }
    requestAnimationFrame(step);

    // Filet de securite : si rAF ne tourne pas (onglet masque, economie
    // d'energie...), on se deplace d'un coup plutot que de ne rien faire.
    setTimeout(function () {
      if (finished || ticked) return;
      window.scrollTo(0, targetY);
      finish();
    }, 300);
    // et si l'animation demarre mais reste bloquee
    setTimeout(function () {
      if (finished) return;
      window.scrollTo(0, targetY);
      finish();
    }, duration + 500);
  }

  function flash(el) {
    if (!el) return;
    var prevShadow = el.style.boxShadow;
    var prevTransition = el.style.transition;
    el.style.transition = 'box-shadow .3s ease';
    el.style.boxShadow = '0 0 0 3px rgba(110,16,15,.45)';
    setTimeout(function () {
      el.style.boxShadow = prevShadow;
      el.style.transition = prevTransition;
    }, 1400);
  }

  function goToBuyBox() {
    // On vise directement le selecteur de pack : un seul mouvement, pas de
    // detour par le haut de la fiche produit.
    var qty = pick(QTY_SELECTORS);
    var box = qty ? (qty.closest('.quantity-breaks-container') || qty) : pick(MAIN_SELECTORS);
    if (!box) return;

    var off = headerOffset();
    var top = window.pageYOffset + box.getBoundingClientRect().top - off - 12;

    animateTo(top, 600, function () {
      flash(box);
    });
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target && evt.target.closest
      ? evt.target.closest('[data-crs-scroll]')
      : null;
    if (!trigger) return;
    evt.preventDefault();
    if (animating) return;
    goToBuyBox();
  }, true);
})();
